import React from 'react';
import AboutBelowContent02 from '../../Components/ExperienceBlocks/AboutBelowContent02';

const ExperienceAbout = () => {
    const headerData = {
        heading: 'Innovazione e Sostenibilità nella Costruzione',
        subheading: 'RB Costruzioni',
    };

    const ExpericenData = [
        {
            id: '1',
            title: 'La Nostra Missione',
            description: 'RB Costruzioni è una società di costruzioni sicura, affidabile ed economica. Offriamo i migliori servizi di costruzione e ristrutturazione per creare edifici residenziali di alta qualità.',
            img: 'images/about/t1.png'
        },
        {
            id: '2',
            title: 'La Nostra Visione',
            description: 'Vogliamo essere leader nel settore della costruzione, promuovendo soluzioni innovative, sostenibili ed efficienti per ogni progetto. La qualità è al centro di tutto ciò che facciamo.',
            img: 'images/about/t2.png'
        },
    ];

    return (
        <div className="experience" style={{ marginTop: '100px' }}>
            <div className="container">
                <div className="row">
                    {/* Left Column: Experience Block */}
                    <div className="col-lg-6">
                        <div className="group_image_holder type_1">
                            <div className="expe_box">
                                <div className="expe_box_inner">
                                    <h1>17</h1>
                                    Anni di Esperienza
                                </div>
                            </div>
                            <img src="images/about/1.png" alt="Experience Image" />
                            <div className="object">
                                <img src="images/about/3.png" alt="About" />
                                <img src="images/about/3.png" alt="About" />
                                <img src="images/about/3.png" alt="About" />
                                <img src="images/about/s1.png" alt="About" />
                            </div>
                        </div>
                    </div>

                    {/* Right Column: Experience Content */}
                    <div className="col-lg-6 col-md-12">
                        <div className="experience_content about">
                            <div className="section_header">
                                <h6 className="section_sub_title">{headerData.subheading}</h6>
                                <h1 className="section_title">{headerData.heading}</h1>
                                <p className="section_desc">
                                    RB Costruzioni offre una gamma completa di servizi di costruzione e ristrutturazione, con oltre 17 anni di esperienza nel settore. Siamo specializzati nella costruzione di edifici residenziali, fornendo soluzioni innovative e di alta qualità in ogni fase del processo. Dalla progettazione all'esecuzione, siamo impegnati a garantire risultati duraturi.
                                </p>
                                <div className="about_below">
                                    {
                                        ExpericenData.map(data =>
                                            <AboutBelowContent02
                                                key={data.id}
                                                data={data}
                                            />
                                        )
                                    }
                                </div>
                            </div>
                            {/* <a className="button" href="/about">Scopri di più</a> */}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ExperienceAbout;
